import React, { useRef, useEffect, useState } from "react";

import styled, { css } from "styled-components";

const Scene = ({ children, isFirst = undefined, fadeIn = "true", fadeOut = "true", isDark = undefined, customMarginTop = undefined, isLight = undefined, sceneHeight = undefined, sceneIndex = undefined, setSceneIndex = undefined }) => {

  const refContent = useRef();
  const [isActive, setIsActive] = useState(false);

  function handleIntersect(entries, observer) {
    ( entries[0].intersectionRatio > 0.65 ) ? setIsActive(true) : setIsActive(false);
  }

  useEffect(() => {
    isActive && sceneIndex !== undefined && setSceneIndex && setSceneIndex(sceneIndex);
  }, [isActive])

  function setupObserver(el) {
    let observer;
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: [0.5,0.55,0.6,0.65,0.7,0.8]
    };
    observer = new IntersectionObserver(handleIntersect, options);
    observer.observe(el);
  }

  useEffect(() => {
    refContent.current && setupObserver(refContent.current);
  }, []);


  return (
    <StyledScene 
      isFirst={isFirst} 
      customMarginTop={customMarginTop}
      isDark={isDark} 
      isLight={isLight}
      sceneHeight={sceneHeight}
      className={isActive && 'is-active'}
    >
      <div>
        {children}
      </div>
      <span  ref={refContent}></span>
    </StyledScene>
  )
}
export default Scene;


const StyledScene = styled.div`
  position: relative;
  height: ${props => props.sceneHeight ? props.sceneHeight : 'var(--scene-height)'};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  order: 0;
  margin-top: ${props => props.isFirst === "true" ? '0' : '-50vh'};
  ${props => props.customMarginTop && css`
    margin-top: ${props.customMarginTop};
  `}
  > div {
    position: sticky;
    display: block;
    top: 0;
    height: 100vh;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-right: var(--gutter);
    padding-left: var(--gutter);
    ${props => props.isDark === "true" && css`
      background-color: var(--theme-background-dark);
      color: var(--theme-text-against-dark);
    `}
    ${props => props.isLight === "true" && css`
      background-color: var(--theme-background-light);
      color: var(--theme-text-against-light);
    `}
  }

  > div {
    opacity: 0;
    filter: blur(4px);
    transition: opacity 0.3s ease, filter 0.3s ease;
  }
  &.is-active > div {
    opacity: 1;
    filter: blur(0);
  }
  > span {
    position: sticky;
    top: 0;
    width: 1px;
    display: block;
    margin-top: -100vh;
    height: 150vh;
    margin-bottom: 25vh;
    align-self: flex-start;
  }
`
